<template>
  <div>
    <!-- mensajes de confirmacion -->
    <mensajeSistema></mensajeSistema>

    <!-- /////////////////////////////////////////////////////
            //    PANTALLA PRINCIPAL                            //
        ///////////////////////////////////////////////////////////    -->
    <v-row>
      <v-col cols="12">
        <ComundataTablecomp :headers="AsignacionCursosHeaders" :items="SeccionGrado" :search="search" whitSearch
          noResultsText="Sin cursos por asignar">
          <template v-slot>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <AutocompleteComp textLabel="Nivel" v-model="id_nivel" :items="NivelesAdmin" item-text="desc_nivel"
                  item-value="id_nivel_adm_nivel" @change="getAllGradosAdmin(id_nivel)" />
              </v-col>

              <v-col cols="12" sm="6" md="6">
                <AutocompleteComp textLabel="Grado" v-model="items" :items="GradosAdmin" item-text="desc_grado"
                  item-value="items" return-object @change="getAllSeccionesGrados(items)" />
              </v-col>
            </v-row>
          </template>
          <template v-slot:action="{ item }">
            <div class="d-flex gap-10px">
              <TableButtonComp verButton v-if="componenteEvento.visualizar_submodulo" @click="getAllCursosSeccion(item)"
                tooltipText="Ver cursos" />
              <TableButtonComp addButton v-if="componenteEvento.agregar_submodulo" @click="getAllCursosGrados(item)"
                tooltipText="Agregar cursos" />
            </div>

          </template>
        </ComundataTablecomp>
      </v-col>

    </v-row>


    <!--------   pantalla principal   ------>

    <!-- modal de cursos  por secciones-->
    <ComunDialogComp v-model="modal_Cursos_Seccion" max-width="1000" @close-modal="modal_Cursos_Seccion = false">
      <template v-slot:title>
        Cursos de la sección : {{ titulo_seccion }}
      </template>
      <template v-slot:body>
        <v-row>
          <v-col cols="12" v-if="mostrarMensaje">
            <v-card outlined>
              <v-card-text style="height:500px" class="text-center d-flex justify-center align-center">
                <span class="">
                  Aún no se ha agregado cursos a esta
                  sección
                </span>
              </v-card-text>
            </v-card>

          </v-col>

          <v-col cols="12" sm="4" md="3" lg="3" class="d-flex justify-center" v-for="item in cursosSecciones"
            :key="item.id">
            <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color }">
              <v-list-item>
                <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                  <v-icon dark>{{ item.icono_curso }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                  <span class="mb-1 font-weight-bold black--text">{{
                    item.desc_curso
                  }}</span>
                  <v-list-item-title class="caption">Área: {{ item.desc_area }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-card-text :style="{ background: item.color }" id="text">{{ item.desc_nivel }} -
                {{ item.desc_grado }}</v-card-text>

              <v-card-actions>
                <v-spacer />
                <TableButtonComp deleteButton v-if="componenteEvento.borrar_submodulo" tooltipText="Eliminar curso"
                  @click="showmodalDelete(item)" />
              </v-card-actions>
            </v-card>
          </v-col>


        </v-row>
      </template>
    </ComunDialogComp>

    <!----- fin del modal cursos -->

    <!-- modal de cursos -->
    <ComunDialogComp v-model="modal_Cursos" maxWidth="1000" @close-modal="modal_Cursos = false">
      <template v-slot:title>
        Agregar curso a la sección :
        {{ titulo_seccion2 }}
      </template>
      <template v-slot:body>
        <v-row wrap>
          <v-col cols="12" v-if="mostrarMensaje2">
            <v-card outlined>
              <v-card-text style="height:500px" class="text-center d-flex justify-center align-center">
                <span class="">
                  Aún no existen cursos registrados para
                  este grado
                </span>
              </v-card-text>
            </v-card>

          </v-col>
          <v-col cols="12" v-if="cursos.length" class="d-flex align-center">
            <span>Seleccionar todos</span>
            <v-checkbox class="ml-2" color="success" key="commonCheck" v-model="checkboxValue"
              @change="toggleAllCheckbox($event)">
            </v-checkbox>
            <v-spacer />
            <TableButtonComp :disabled="checkedItems.length === 0" v-if="cursos.length" @click="saveAllCursosBtn()"
              normalButton textButton="Guardar cursos" iconBut="fas fa-save" />
          </v-col>

          <v-col cols="12" sm="4" md="3" lg="3" v-for="item in cursos" :key="item.id">
            <v-card width="240" elevation="7" :style="{ 'border-left': 'solid 5px' + item.color }">
              <v-list-item>
                <v-list-item-avatar class="ml-0 mr-1" size="50" :color="item.color_curso">
                  <v-icon dark>{{ item.icono_curso }}</v-icon>
                </v-list-item-avatar>

                <v-list-item-content class="py-0">
                  <span class="mb-1 font-weight-bold black--text">
                    {{ item.desc_curso }}</span>
                  <v-list-item-title class="caption">Área: {{ item.desc_area }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-card-text :style="{ background: item.color }" id="text">{{ item.desc_nivel }} -
                {{ item.desc_grado }}</v-card-text>

              <v-card-actions>
                <v-spacer />
                <v-checkbox color="success" v-model="checkedItems" :value="item" :key="item.id" hide-details>
                </v-checkbox>
              </v-card-actions>
            </v-card>
          </v-col>

        </v-row>
      </template>

    </ComunDialogComp>

    <!-- fin del modal cursos -->

    <!-- modal de cursos  confirmacion-->
    <ComunDialogComp v-model="modal_aceptar" maxWidth="550" title="Confirmar" @close-modal="modal_aceptar = false">
      <template v-slot:body>
        <span class="text-h6">
          ¿Está seguro de agregar los "cursos" seleccionados a la
          "sección" {{ titulo_seccion2 }}?
        </span>
        <div v-for="(curso, index) in checkedItems" :key="index">
          <v-avatar size="30" :color="curso.color_curso">
            <v-icon dark small>{{ curso.icono_curso }}</v-icon>
          </v-avatar>

          <v-chip color="white font-weight-black">
            <h3>{{ curso.desc_curso }}</h3>
          </v-chip>
          -
          <v-chip label :color="curso.color" class="white--text">
            {{ curso.desc_nivel }} - {{ curso.desc_grado }}
          </v-chip>
        </div>

      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-btn class="btn_style3" dark @click="modal_aceptar = false">No</v-btn>
        <v-btn class="btn_block_style2" dark @click="addCursosSecciones">SÍ</v-btn>
      </template>
    </ComunDialogComp>

    <confirm @aceptar="deleteItem" titleWindow="Eliminar curso" @cancelar="clear_confirm" :title="confirm.title"
      :active="confirm.active" />
  </div>
</template>



<script>
import axios from "../../helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import TableButtonComp from '../../components/ComponentsEst/TableButtonComp.vue';
import ComunDialogComp from '../../components/ComponentsEst/ComunDialogComp.vue';
import ComundataTablecomp from '../../components/ComponentsEst/ComundataTablecomp.vue';
import AutocompleteComp from '../../components/ComponentsEst/AutocompleteComp.vue';
import { AsignacionCursosHeaders } from '../../helpers/headersTable';

export default {
  components: {
    TableButtonComp,
    ComunDialogComp,
    ComundataTablecomp,
    AutocompleteComp
  },
  data: () => ({
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    paramComponente: { id_submodulo: 39, id_modulo: 6 }, //sud_modulo y modulo

    AsignacionCursosHeaders,
    datoLogin: sessionStorage, // variables de sesion del usuario
    ////////////////////////////////////////////////////////
    checkedItems: [],
    cursoAgregar: [],
    checkboxValue: false,
    confirm: {
      //id: 0,
      //nombre_seccion: "",
      title: "",
      active: false,
    },
    dataSend: {
      id: 0,
      id_seccion: 0,
      nombre_seccion: "",
    },
    // consulta princial
    id_nivel: 0,
    items: [],
    NivelesAdmin: [],
    GradosAdmin: [],

    search: "",
    SeccionGrado: [],

    /////////////////////////////

    // modal ver cursos
    modal_Cursos_Seccion: false,
    titulo_seccion: "",
    mostrarMensaje: false,
    cursosSecciones: [],
    paramSeccion: {
      id_colegio: sessionStorage.id_colegio,
      id_anio_lectivo: sessionStorage.id_ano_lectivo,
      id_seccion: 0,
    },
    /////////////////////////

    // modal agregar curso
    modal_Cursos: false,
    titulo_seccion2: "",
    seccion_seccionada: [],
    mostrarMensaje2: false,
    cursos: [],

    /* headers_cursos: [
                { text: 'id', align: 'left', sortable: false, value: 'id',},
                { text: 'Nombre del Curso', value: 'desc_curso' },
                { text: 'Grado', value: 'desc_grado' },
                { text: 'Area', value: 'desc_area' },
                {text: 'Agregar', value: 'agg'},
            ], */
    /////////////////////////

    // modal confirmacion de agregar curso
    modal_aceptar: false,

    ///////////////////////////////////

    parametros: {
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio_adm_nivel: sessionStorage.id_colegio,
    },

    paramCursos: {
      id_colegio: sessionStorage.id_colegio,
      id_anio_lectivo: sessionStorage.id_ano_lectivo,
      id_grado: 0,
      id_seccion: 0,
    },

    editedItem: {
      id_ano_lectivo: sessionStorage.id_ano_lectivo,
      id_colegio: sessionStorage.id_colegio,
      id_seccion: 0,
      id_curso: [],
      id_personal: sessionStorage.id_personal,
      id_usuario: sessionStorage.id,
    }

  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  created() {
    this.actualizarParamentro();
  },

  mounted() {
    this.getAllNivelesAdmin();
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },





    toggleAllCheckbox() {
      if (this.checkboxValue) {
        this.checkedItems = [...this.cursos];
      } else {
        this.checkedItems = [];
      }
    },
    clear_confirm() {
      this.dataSend.id = 0;
      this.dataSend.nombre_seccion = "";
      this.confirm.title = "";
      this.confirm.active = false;
      this.checkedItems = [];
      this.checkboxValue = false;
    },

    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),
    ////////////////////////////////////////////////////////

    //-------traer mis niveles de administracion-------
    async getAllNivelesAdmin() {
      let params = this.parametros;

      try {
        let response = await axios.post(
          "/administrativo/nivel/niveladmin/",
          params
        );
        this.NivelesAdmin = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //---------traer mis grados de administracion por nivel
    async getAllGradosAdmin(id) {
      this.SeccionGrado = [];

      let params = {
        id_ano_lectivo: this.datoLogin.id_ano_lectivo,
        id_colegio: this.datoLogin.id_colegio,
        id_nivel: id,
      };

      //this.miNivel = id

      try {
        let response = await axios.post(
          "/administrativo/grado/gradosNivelAdmin/",
          params
        );
        this.GradosAdmin = response.data;
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //----------secciones por grados ------------
    async getAllSeccionesGrados(items) {
      this.paramCursos.id_grado = items.id_grado; //Se setea el id_grado de mantenimiento

      let params = {
        id_ano_lectivo: sessionStorage.id_ano_lectivo,
        id_colegio: sessionStorage.id_colegio,
        id_grado: items.id, // Se setea el id_grado de adm_grados
      };


      try {
        let response = await axios.post(
          "/administrativo/seccion/seccionGrado/",
          params
        );
        this.SeccionGrado = response.data;

        if (this.SeccionGrado.length === 0) {
          this.setEnviarMens({
            tipo: "W",
            mensaje: "No hay secciones para este curso.",
            tiempo: null,
          });
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //---------obtener los cursos por secciones ---------
    async getAllCursosSeccion(item) {
      console.log(item);
      this.mostrarMensaje = false;
      this.paramSeccion.id_seccion = item.id;
      this.titulo_seccion = item.nombre_seccion;

      try {
        let response = await axios.post(
          "/administrativo/seccionCurso/sc/list/",
          this.paramSeccion
        );
        this.cursosSecciones = response.data;
        //console.log('holaaaa====>>>'+JSON.stringify(this.cursosSecciones))
        this.modal_Cursos_Seccion = true;

        if (this.cursosSecciones.length === 0) {
          this.mostrarMensaje = true;
        }
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //--------traer todos los cursos DE MANTENIMEINTO------
    async getAllCursosGrados(item) {
      this.mostrarMensaje2 = false;
      this.editedItem.id_seccion = item.id;
      this.paramCursos.id_seccion = item.id;
      this.titulo_seccion2 = item.nombre_seccion;
      this.seccion_seccionada = item;

      try {
        let response = await axios.post(
          "/administrativo/curso/detail/list/",
          this.paramCursos
        );
        this.cursos = response.data;
        this.modal_Cursos = true;

        if (this.cursos.length === 0) {
          this.mostrarMensaje2 = true;
        }
        this.checkedItems = []
        this.checkboxValue = false
        //console.log('Cursos====>>>'+JSON.stringify(this.cursos))
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        //console.log(error);
      }
    },

    //------confirmar aceptgacion de curso a seccion ------
    // aggCursoSeccion(item) {
    //   if (this.editedItem.id_curso.includes(item.id)) {
    //     const index = this.editedItem.id_curso.indexOf(item.id);
    //     if (index !== -1) {
    //       this.editedItem.id_curso.splice(index, 1);
    //       this.cursoAgregar.splice(index, 1);
    //     }
    //   } else {
    //     this.editedItem.id_curso.push(item.id);
    //     this.cursoAgregar.push(item);
    //   }
    // },

    saveAllCursosBtn() {
      if (this.editedItem.id_curso.length === 0 && this.checkedItems.length === 0) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `¡No ha encontrado algún curso para guardar!`,
          tiempo: null,
        });
        return
      }
      this.modal_aceptar = true;

    },

    //------------agregar cursos --------------
    async addCursosSecciones() {
      let params = { ...this.editedItem }

      const idcursosSelected = [];
      this.checkedItems.forEach(element => {
        idcursosSelected.push(element.id)
      });

      params.id_curso = idcursosSelected

      if (this.checkedItems.length == 0) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `¡No ha encontrado algún curso para guardar!`,
          tiempo: null,
        });
        return
      }
      // let params = this.editedItem;
      try {
        let response = await axios.post(
          "/administrativo/seccionCurso/",
          params
        );
        this.seccionesCurso = response.data;

        this.modal_aceptar = false;
        this.editedItem.id_curso = [];
        this.checkedItems.checkboxValue = false
        this.checkedItems = []

        this.setEnviarMens({
          tipo: "S",
          mensaje: `¡Información creada con éxito!`,
          tiempo: null,
        });
        this.clear_confirm()
        this.getAllCursosGrados(this.seccion_seccionada);

      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        this.editedItem.id_curso = [];
        //console.log(error);
      }
    },

    async showmodalDelete(item) {
      this.dataSend.id = item.id;
      this.dataSend.id_seccion = item.id_seccion;
      this.dataSend.nombre_seccion = item.nombre_seccion;
      this.confirm.title = "¿Está seguro de eliminar este registro?";
      this.confirm.active = true;
    },
    //-- 02/07/2020. ING RODRIGUEZ ROBERT.
    //-- METODO QUE PERMITE ELIMINAR UN CURSO O ASIGNATURA DE UNA SECCION
    //-- SIEMPRE Y CUANDO NO SE ENCUENTRE ASOCIADO A OTRO REGISTRO EN LA BASE DE DATOS
    async deleteItem() {
      let item2 = {
        id: this.dataSend.id_seccion,
        nombre_seccion: this.dataSend.nombre_seccion,
      };
      try {
        //let cf = await confirm(
        //  "¿Está seguro que desea borrar este registro ****** ?"
        //);
        //if (cf) {
        let response = await axios.delete(
          "/administrativo/seccionCurso/" + this.dataSend.id
        );
        this.setEnviarMens({
          tipo: response.data.messageT,
          mensaje: response.data.message,
          tiempo: null,
        });

        this.clear_confirm();
        this.getAllCursosSeccion(item2);
        //}
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: `${e}`, tiempo: null });
      }
    },




  },

  watch: {
    // Vigila los cambios en el arreglo de checkedItems
    checkedItems: {
      handler: function () {
        // Verifica si todos los checkboxes individuales están marcados
        this.checkboxValue = this.checkedItems.length === this.cursos.length;
      },
      deep: true // Permite observar cambios en subpropiedades del arreglo
    },
  }
}
</script>




<style scoped>
#text {
  color: #ffffff;
  padding: 1%;
  padding-left: 10%;
}
</style>
